import { Paper } from '@mui/material';
import { rem } from '@Utils/styles';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledMap = styled.div`
	height: 100%;
	position: relative;
	overflow: hidden;

	inno-map {
		+ div {
			z-index: 2;
		}
	}

	.filterCardContainer {
		position: absolute;
		top: ${rem(8)};
		left: ${rem(338)};
		z-index: 5;
	}
`;

export default StyledMap;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Popout = styled(Paper)`
	width: 100%;
	height: 100%;
	top: 0%;
	left: 0%;
	position: absolute;
	z-index: 11;
`;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Popout2 = styled(Paper)`
	width: 100%;
	height: 100%;
	top: 0%;
	left: 0%;
	position: absolute;
	z-index: 12;
`;
